import { InputAdapterService } from '@api/services/input-adapter/input-adapter.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InputAdapterCustomService extends InputAdapterService {
  constructor() {
    super();
  }
}
